import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defaultTo, get, isEmpty } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { FeatureFlags } from './constants';

export type FeatureFlagsMap = Map<string, boolean>;

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  // holds the list of feature flags
  private featureFlagList = new Map<string, boolean>();
  private initialSet = new Map<string, boolean>();
  private _featureFlagsMap$ = new BehaviorSubject<FeatureFlagsMap>(this.initialSet);

  constructor(private http: HttpClient) {}

  getAllFeatureFlags(): void {
    this.featureFlagList.clear(); // reset the map
    const featureFlagNames = Object.values(FeatureFlags);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'en-namespace': environment.namespace,
      }),
    };
    const data = {
      featureFlagNames,
    };
    const url = environment.externalServiceUrl + 'fetchFeatureFlags';
    this.http
      .post(url, data, httpOptions)
      .pipe(take(1))
      .subscribe((result) => {
        const featureFlags = defaultTo(get(result, 'featureFlags'), {});
        if (!isEmpty(featureFlags)) {
          featureFlagNames.forEach((featureFlagName) => {
            const value: boolean = defaultTo(
              get(featureFlags, featureFlagName),
              false
            );
            this.featureFlagList.set(featureFlagName, value);
            this._featureFlagsMap$.next(this.featureFlagList)
          });
        }
      });
  }

  getFeatureFlag(ffName: string): boolean {
    return this.featureFlagList.get(ffName);
  }

  isFeatureEnabled$(featureFlagName: string, defaultIfFeatureMissing: boolean = false): Observable<boolean> {
    return this._featureFlagsMap$.pipe(
      map((flags) => {
        return flags.has(featureFlagName) ? flags.get(featureFlagName) : defaultIfFeatureMissing;
      })
    );
  }
}
